<div class="header-actions">
    <button class="close" (click)="modalService.close()" title="{{ 'generic.close' | translate }}">
        <span class="icon-view-close" aria-hidden="true">
            <svg>
                <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
            </svg>
        </span>
        <span>{{ 'generic.close' | translate }}</span>
    </button>
</div>

<h2 *ngIf="modalService.currentDatas.titleRef" [innerHtml]="modalService.currentDatas.titleRef | translate"></h2>
<h2 *ngIf="modalService.currentDatas.title" [innerHtml]="modalService.currentDatas.title"></h2>
<div class="text-center mb-4 mt-3" *ngIf="modalService.currentDatas.contentRef" [innerHtml]="modalService.currentDatas.contentRef | translate:modalService.currentDatas.contentArgs"></div>
<p class="text-center mb-4" *ngIf="modalService.currentDatas.content" [innerHtml]="modalService.currentDatas.content"></p>
<div class="text-center">
    <ng-hbm-bdi-btn class="primary mr-2" *ngFor="let button of modalService.currentDatas.buttons" (click)="button.action()" [label]="(button.labelRef ? (button.labelRef | translate) : button.label)"></ng-hbm-bdi-btn>
</div>